<template>
  <div class="wrap">
    <div class="navbar">
      <div class="logo">
        <img :src="logoImg"/>
      </div>

      <div class="nav">
<!--        <div class="dropdown">-->
<!--          <button class="drop-btn" @click="funRouter">服务支持</button>-->
<!--          <div class="dropdown-content">-->
<!--            <router-link to="/support">服务支持</router-link>-->
<!--            <router-link to="/registry">服务注册</router-link>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="dropdown">-->
<!--          <button class="drop-btn" @click="funRouter2">慧云心境</button>-->
<!--          <div class="dropdown-content">-->
<!--            <router-link to="/introduction">公司介绍</router-link>-->
<!--            <router-link to="/contact">联系我们</router-link>-->
<!--          </div>-->
<!--        </div>-->

<!--        <ul>-->
<!--          <li-->
<!--              v-for="(item, index) in navList"-->
<!--              :key="index"-->
<!--              @click="routerHandle(item.url)"-->
<!--          >-->
<!--            {{ item.title }}-->
<!--          </li>-->
<!--        </ul>-->
<!--        <div class="dropdown-content" v-if="hover">-->
<!--          <router-link to="/support">服务支持</router-link>-->
<!--          <router-link to="/registry">服务注册</router-link>-->
<!--        </div>-->
        <ul>
          <li @click="routerHandle('/')">首页</li>
          <li @click="routerHandle('/products')">产品中心</li>
          <li @click="routerHandle('/cooperation')">商务合作</li>
          <li class="service-nav" @click="funRouter">服务支持
            <div class="dropdown-content">
              <a href="#/support">服务支持</a>
              <a href="#/registry">服务注册</a>
            </div>
          </li>
          <li class="service-nav" @click="funRouter2">慧云心境
            <div class="dropdown-content">
              <a href="#/introduction">公司介绍</a>
              <a href="#/contact">联系我们</a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return {
      navList: [
        {title: "首页", url: "/"},
        {title: "产品中心", url: "/products"},
        {title: "商务合作", url: "/cooperation"},
        {title: "服务支持", url: "/support"},
        {title: "慧云心境", url: "/introduction"},
      ],
      logoImg: require("../assets/img/hy-logo2.png"),
      hover: false
    };
  },
  methods: {
    routerHandle(msg) {
      this.$router.push(msg);
    },
    funRouter() {
      this.$router.push("/support");
    },
    funRouter2() {
      this.$router.push("/introduction");
    }
  },
};
</script>
<style scoped>
body,
h1,
h2,
h3,
h4,
h5,
h6,
div,
p,
dl,
dt,
dd,
ol,
ul,
li,
form,
table,
th,
td,
a,
img,
span,
strong,
var,
em,
input,
textarea,
select,
option {
  margin: 0;
  padding: 0;
}
.wrap {
  position: relative;
  /*我们假设pad的设计稿是以1920px为标准的。那么：*/
  /*100vw = 1920px*/
  /*1vw = 19.2px*/
  /*width: 1920px;*/
  /*height: 70px;*/
  width: 100vw;
  height: 3.64vw;
  background-color: rgba(255, 255, 255, 1);
}

.navbar {
  height: 70px;
}

/*.wrap > .logo > img {*/
/*  position: absolute;*/
/*  left: 360px;*/
/*  !*top: 23px;*!*/
/*  width: 181px;*/
/*  height: 54px;*/
/*}*/

.logo {
  position: absolute;
  left: 360px;
  top: 10px;
  width: 162px;
  height: 46px;
}

.logo img {
  width: 162px;
  height: 46px;
}

.nav {
  width: 750px;
  position: absolute;
  left: 1000px;
  height: 70px;
  /*top: -9px;*/
  top: 30px;
}

.nav ul {
  height: 70px;
}

.nav ul li {
  height: 30px;
  float: left;
  display: flex;
  list-style-type: none;
  font-weight: 500;
  color: #45657F;
  font-size: 16px;
  margin-right: 55px;
  line-height: 10px;
  cursor: pointer;
}

.nav ul li:hover {
  color: rgba(35, 51, 127, 1);
  border-bottom: 2px solid rgba(35, 51, 127, 1);
}

.drop-btn {
  background-color: #fff;
  font-weight: 500;
  color: #45657F;
  /*padding: 16px;*/
  font-size: 16px;
  border: none;
  cursor: pointer;
  min-width: 120px;
  /*height: 59px;*/
}

.drop-btn:hover {
  color: rgba(35, 51, 127, 1);
}

.dropdown {
  top: 32px;
  left: 340px;
  min-width: 120px;
  /*height: 59px;*/
  position: relative;
  display: inline-block;
}

.dropdown-content {
  margin-top: 28px;
  /*margin-left: 295px;*/
  margin-left: -30px;

  z-index: 999;
  text-align: center;
  display: none;
  position: absolute;
  /*background-color: #f9f9f9;*/
  background: #4B72B8;
  /*min-width: 95px;*/
  /*min-height: 120px;*/
  min-width: 120px;
  min-height: 80px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
}

.dropdown-content a {
  color: #FFFFFF;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  font-size: 16px;
}

.dropdown-content a:hover {
  background: #4B72B8;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.service-nav:hover .dropdown-content {
  display: block;
}
</style>
